import React from 'react'
import PropTypes from 'prop-types'
import EmailChip from '../../atoms/EmailChip'

export const SentTo = ({ email }) => {
  return (
    <React.Fragment>
      <div className="flex mb-1 justify-center">
        <span className="typo-body-medium">Digite o código enviado para</span>
      </div>
      <div className="flex mb-4 justify-center">
        <EmailChip>{email}</EmailChip>
      </div>
    </React.Fragment>
  )
}

SentTo.propTypes = {
  email: PropTypes.string,
}
